import { Injectable } from "@angular/core";
import { TransactionNotifyService } from "./transaction.notify.service";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";
import { FiatTransaction } from "@models/transaction";
import { Router } from "@angular/router";

@Injectable({
	providedIn: "root"
})
export class FiatTransactionNotifyService extends TransactionNotifyService<FiatTransaction> {
	protected LABEL: string = "fiat";

	public constructor(
		public router: Router,
		protected translationService: TranslationService,
		protected infoService: InfoService
	) {
		super(router);
	}

	protected caseNew(transaction: FiatTransaction): string {
		if (transaction.getType() === "deposit") {
			return "some-additional-text-for-deposit-success";
		}
		if (transaction.getType() === "withdrawal") {
			return "withdraw-successful";
		}
		if (transaction.getType() === "transfer") {
			return "transfer_type_fiatTx_message";
		}

		return "";
	}
}
